export const phone = '+44 (0) 7595 324 954';
export const phoneLink = '+447595324954';
export const email = 'info@updownstairs.com';